import React from 'react';
import {useSelector} from 'react-redux'
import * as S from './GoSafePersuation.styles';

const GoSafePersuationTag = props => {

  return (
    <S.GoSafePersuation>
      <S.Content>
        <img src='https://gos3.ibcdn.com/goSafelogo-1591083260.png' alt="" width="70px" />

        <S.Info>
  <span>{props.ps}</span>
        </S.Info>
      </S.Content>
      
    </S.GoSafePersuation>
  );
};

export default GoSafePersuationTag;
